import { useLayoutEffect, useState } from 'react'

const MAIN_SCROLLABLE_AREA_ID = 'main-scrollable-area'

export const useMainScrollableElement = () => {
  const [scrollElement, setScrollElement] = useState<HTMLElement | null>(null)

  useLayoutEffect(() => {
    setScrollElement(document.getElementById(MAIN_SCROLLABLE_AREA_ID))
  }, [])

  return scrollElement
}

